import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "./style.scss";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import Tabs from "../common/Tabs";
import AcknowledgeProjects from "./acknowledge";
import ArchivedProjects from "./archived";

const Documents: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const { customerEnabled } = useAppSelector((state) => state?.auth);

  const handleTabChange = (tab: number): void => {
    setActiveTab(tab);
  };

  const tabs = customerEnabled
    ? [
      {
        label: "Acknowledged projects",
        content: (
          <div className="mx-[12px] bg-darkcolor-700">
            <AcknowledgeProjects />
          </div>
        ),
      },
    ]
    : [
      {
        label: "Acknowledged projects",
        content: (
          <div className="mx-[12px] bg-darkcolor-700">
            <AcknowledgeProjects />
          </div>
        ),
      },
      {
        label: "Archived projects",
        content: (
          <div className="px-[12px]">
            <ArchivedProjects />
          </div>
        ),
      },
    ];

  return (
    <div className="h-full flex-1">
      <ToastContainer />
      <div className="flex items-center justify-between px-[32px] py-[12px] bg-darkcolor-700 h-[72px] border-b-[1px] border-darkcolor-400">
        <p className="text-neutral-25 text-[23px] font-medium">Documents</p>
      </div>
      <div className="bg-darkcolor-700 pt-[28px] sticky top-[72px] documents">
        <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} bgColor="bg-darkcolor-800" className="" />
      </div>
    </div>
  );
};

export default Documents;
